/**
 * Checks if the given event corresponds
 * to an click event or a keydown event
 * for a enter key press.
 * @param {Event} e - The event object to check
 */
export function isClickOrEnter(e) {
    if (e) {
        let event;

        if (Object.prototype.hasOwnProperty.call(e, 'originalEvent')) {
            // this is probably a jQuery event so get the originalEvent
            event = e.originalEvent;
        } else {
            event = e;
        }

        if (event instanceof UIEvent) {
            return e.type === 'click' || (e.type === 'keydown' && e.keyCode === 13);
        }
    }

    return false;
}

export const generateId = (() => {
    const generatedIds = new Set();
    const letterCharset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIKLMNOPQRSTUVWXYZ';
    const numberCharset = '0123456789';
    const completeCharset = letterCharset + numberCharset;

    function pickRandomCharacter(charset) {
        return charset[Math.floor(Math.random() * charset.length)];
    }

    function generate(length) {
        // first character should always be a letter
        // so pick a random character from the
        // letter charset
        let id = pickRandomCharacter(letterCharset);

        for (let i = 0, iLen = length - 1; i < iLen; i++) {
            // then continue picking characters from the complete charset
            id += pickRandomCharacter(completeCharset);
        }

        return id;
    }

    return (length) => {
        const len = length || 8;

        let id;

        do {
            id = generate(len);
        }
        while (generatedIds.has(id));

        generatedIds.add(id);
        return id;
    };
})();

/**
 * Returns the offset height of an element
 * @param {*} htmlElementOrJqueryObject - The element to measure
 */
export function getElementScrollHeight(htmlElementOrJqueryObject) {
    let element;

    if (isjQueryObject(htmlElementOrJqueryObject)) {
        // element is already a jquery object
        // eslint-disable-next-line prefer-destructuring
        element = htmlElementOrJqueryObject[0];
    } else {
        element = htmlElementOrJqueryObject;
    }

    return Math.round(element.scrollHeight);
}

/**
 * Checks if the given object is a jQuery object
 * @param {*} object - The object to check
 */
export function isjQueryObject(object) {
    return object instanceof window.jQuery || object instanceof window.$;
}

/**
 * No operation function
 */
export function noop() { }

/**
 * Parses HTML into a DocumentFragment
 * @param {string} html - The HTML string to parse
 * @returns DocumentFragment
 */
export function parseHtml(html) {
    return document.createRange().createContextualFragment(html);
}

export const decodeHtml = (() => {
    const textarea = document.createElement('textarea');

    return (html) => {
        textarea.innerHTML = html || '';
        return textarea.value;
    };
})();
